import React, { useEffect, Component, useState, useRef } from "react";
import Button from "@mui/material/Button";
import Table from "react-bootstrap/Table";
import AddIcon from "@mui/icons-material/Add";
import "../../admin.css";
import { BsThreeDotsVertical } from "react-icons/bs";
import Sidebar from "../../SideNav/sideBar";
import Dropdown from "react-bootstrap/Dropdown";
import { OverlayTrigger, Popover } from "react-bootstrap";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Stack,
  FormControl,
  Select,
  MenuItem,
  TextField,
  Pagination,
  PaginationItem,
  Tabs,
  Tab,
  Chip,
} from "@mui/material";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { MdRemoveRedEye, MdDelete, MdMode } from "react-icons/md";
import CustomSnackbar from "../../../Components/notify/Snackbar";
import { apiAdminConfig } from "../../../utils/api";
import Nodata from "../../../Components/nodata/Nodata";
import Popup from "../../../Components/popup/Popup";
import Loader from "../../../Components/Loader/Loader";
import PropTypes from "prop-types";
import ViewInvoiceModal from "./dialog";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};
const Contant = () => {
  const navigate = useNavigate();

  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isInvoiceOpen, setIsInvoiceOpen] = useState(false);
  const [snackData, setsnackdata] = React.useState({
    open: false,
    message: "",
    status: "",
  });
  const [open, setOpen] = useState(false);
  const [debouncedSearch,setDebouncedSearch] = useState("");
  const [searchParams, setSearchParams] = useSearchParams();
  const initialPage = Number(searchParams.get("page")) || 1;

  const [page, setPage] = React.useState(initialPage);
  const [pageCount, setPageCount] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(10);
  const cacheRef = useRef({});
  const controllerRef = useRef(null); // for cancelling in-flight requests
  let tablehead = [
    "S/N",
    "Job ID",
    "Invoice ID",
    "Job Name",
    "Vehicle Name",
    "Bid Count",
    "Payment",
    "Status",
    "Action",
  ];
  const [search, setSearch] = useState("");
  const initialTab = searchParams.get("tab") || "customer";
  const [value, setValue] = React.useState(initialTab);

  const handlePageChange = (event, value) => {
    setPage(value);
    setSearchParams({ page: value, tab: value });
  };

  const handlePageSizeChange = (event) => {
    setPageSize(event.target.value);
  };

  React.useEffect(() => {
    setSearchParams({ page, tab: value });
  }, [page, value, setSearchParams]);

  const extractSearchValue = (searchValue) => {
  if (!searchValue || isNaN(searchValue)) return searchValue; // text search support

  // ✅ Otherwise return as-is
  return searchValue.toString();
};


  const fetchdata = async (search_value, { backgroundOnly = false } = {}) => {
    const key = `${value}|${page}|${pageSize}|${search_value || ""}`;

    // If we have cached data for this query, show it immediately (unless backgroundOnly)
    const cached = cacheRef.current[key];
    if (cached && !backgroundOnly) {
      setPosts(cached.data);
      setPageCount(cached.pageCount);
      setPageSize(cached.pageSize);
      setLoading(false);
    }

    // Cancel previous in-flight request
    try {
      if (controllerRef.current) controllerRef.current.abort();
    } catch (e) {}
    const controller = new AbortController();
    controllerRef.current = controller;

    // Fetch fresh data (in backgroundOnly mode we still update cache but don't set posts)
    try {
      const response = await apiAdminConfig.get("api/auth/master/jobs/list", {
        params: {
          search: !search_value || search_value === "" ? 0 : extractSearchValue(search_value),
          per_page: pageSize,
          page: page,
          type: value,
          is_deleted: 0,
        },
        signal: controller.signal,
      });
      if (response.status === 200) {
        const meta = response?.data?.view_data?.meta || {};
        const raw = response?.data?.view_data?.data || [];

        // Transform data once to avoid repeated work during render
        const data = raw.map((item) => {
          let vehicleDisplay = "N/A";
          try {
            const arr = JSON.parse(item?.vehicle || "[]");
            vehicleDisplay = (arr && arr[0] && String(arr[0]).trim()) || "N/A";
          } catch (e) {
            vehicleDisplay = "N/A";
          }
          const jobDisplayId = item?.id ? item.id + 1000 : "N/A";
          const invoiceString = item?.completed_on && item?.invoice_id
            ? `${item.completed_on.replaceAll("-", "")}00${item.invoice_id}`
            : "Pending";
          return {
            ...item,
            vehicleDisplay,
            jobDisplayId,
            invoiceString,
            jobRequestsCount: (item?.job_requests && item.job_requests.length) || 0,
          };
        });

        // Update cache
        cacheRef.current[key] = {
          data,
          pageCount: meta.last_page,
          pageSize: meta.per_page,
        };

        if (!backgroundOnly) {
          setPageCount(meta.last_page);
          setPageSize(meta.per_page);
          setPosts(data);
          setLoading(false);
        }
      }
    } catch (error) {
      if (error.name === 'CanceledError' || error.name === 'AbortError') {
        // request was cancelled, ignore
        return;
      }
      if (!backgroundOnly) setLoading(false);
      console.log("error", error);
    }
  };

  useEffect(() => {
      const handler = setTimeout(() => {
        setDebouncedSearch(search);
      }, 1000); 
  
      return () => {
        clearTimeout(handler); 
      };
    }, [search]);

  React.useEffect(() => {
    fetchdata(debouncedSearch);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
        fetchdata(debouncedSearch);
      }, [debouncedSearch, page, pageSize, value]);

  // Prefetch the other tab in background to make switching instant
  useEffect(() => {
    const other = value === "customer" ? "company" : "customer";
    const prefetch = async () => {
      const key = `${other}|1|${pageSize}|${debouncedSearch || ""}`;
      // if already cached, skip
      if (cacheRef.current[key]) return;
      try {
        const response = await apiAdminConfig.get("api/auth/master/jobs/list", {
          params: {
            search: !debouncedSearch || debouncedSearch === "" ? 0 : extractSearchValue(debouncedSearch),
            per_page: pageSize,
            page: 1,
            type: other,
            is_deleted: 0,
          },
        });
        if (response.status === 200) {
          const meta = response?.data?.view_data?.meta || {};
          const raw = response?.data?.view_data?.data || [];
          const data = raw.map((item) => {
            let vehicleDisplay = "N/A";
            try {
              const arr = JSON.parse(item?.vehicle || "[]");
              vehicleDisplay = (arr && arr[0] && String(arr[0]).trim()) || "N/A";
            } catch (e) {
              vehicleDisplay = "N/A";
            }
            const jobDisplayId = item?.id ? item.id + 1000 : "N/A";
            const invoiceString = item?.completed_on && item?.invoice_id
              ? `${item.completed_on.replaceAll("-", "")}00${item.invoice_id}`
              : "Pending";
            return {
              ...item,
              vehicleDisplay,
              jobDisplayId,
              invoiceString,
              jobRequestsCount: (item?.job_requests && item.job_requests.length) || 0,
            };
          });
          cacheRef.current[key] = {
            data,
            pageCount: meta.last_page,
            pageSize: meta.per_page,
          };
        }
      } catch (e) {
        // ignore prefetch errors
      }
    };
    prefetch();
  }, [value, pageSize, debouncedSearch]);

  const handleClose = () => {
    setOpen(false);
  };

  const updateStatus = async (id, status) => {
    console.log("error---->", id, status);
    const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
    setsnackdata({
      open: false,
      message: "",
      status: "success",
    });

    let apiEndpoint = "";
    let statusType = "";

    if (!status) {
      apiEndpoint = `api/auth/master/verify-user/${id}`;
      statusType = "success";
    } else if (status === 1) {
      apiEndpoint = `api/auth/master/customer/status/deactive/${id}`;
      statusType = "success";
    } else if (status === 2) {
      apiEndpoint = `api/auth/master/customer/status/active/${id}`;
      statusType = "success";
    } else {
      console.error("Invalid status");
      return;
    }

    try {
      const response = await apiAdminConfig.get(apiEndpoint);
      if (response && response?.status === 200) {
        fetchdata();
        await wait(1000); // Assuming you have a wait function
        setsnackdata({
          open: true,
          message: response.data.message,
          status: statusType,
        });
      }
    } catch (error) {
      console.log("error---->", error);
    }
  };

  //handle Delete function
  const handleDelete = async (id) => {
    setOpen(id);
  };

  const [selectOpen, setSelectOpen] = React.useState(false);

  const handleSelectClose = () => {
    setSelectOpen(false);
  };

  const handleOpen = () => {
    setSelectOpen(true);
  };

  const handleJobChange = (event, newValue) => {
    setValue(newValue);
    // fetchdata(newValue);
    setSearchParams({ page: 1, tab: newValue });
    setPage(1);
  };
  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <>
          <CustomSnackbar value={snackData} />
          <Card
            sx={{
              boxShadow: "none!important",
              borderRadius: "20px!important",
              mt: 4,
            }}
          >
            <CardContent>
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <Tabs
                  value={value}
                  onChange={handleJobChange}
                  aria-label="basic tabs example"
                >
                  {/* <Tab label="Admin" value="admin" /> */}
                  <Tab label="Customer" value="customer" />
                  <Tab label="Company" value="company" />
                </Tabs>
              </Box>
              <Stack
                direction="row"
                justifyContent="space-between"
                mb={8}
                mt={3}
              >
                <Box>
                  <Typography
                    component="h3"
                    sx={{
                      fontSize: "30px",
                      fontWeight: 500,
                      textTransform: "capitalize",
                    }}
                  >
                    {value} Jobs
                  </Typography>
                </Box>
                <Box>
                  {/* <Button
                    variant="outlined"
                    color="primary"
                    sx={{
                      textTransform: "none",
                      borderRadius: "15px",
                      padding: "0.875rem 1.5rem",
                      fontSize: "14px !important",
                      lineHeight: "1",
                    }}
                    startIcon={<AddIcon color="primary" />}
                    onClick={() => {
                      navigate(`/master/job/jobs/${value}/create`);
                    }}
                  >
                    Add Job
                  </Button> */}
                </Box>
              </Stack>
              <Stack
                direction="row"
                justifyContent="space-between"
                mb={2}
                mt={4}
                alignItems="center"
              >
                <Stack direction="row" spacing={1} alignItems="center">
                  <Typography sx={{ fontSize: "13px" }}>Show</Typography>
                  <FormControl size="small">
                    <Select
                      sx={{ fontSize: "13px" }}
                      open={selectOpen}
                      onClose={handleSelectClose}
                      onOpen={handleOpen}
                      value={pageSize}
                      onChange={handlePageSizeChange}
                    >
                      <MenuItem sx={{ fontSize: "13px" }} value={10}>
                        10
                      </MenuItem>
                      <MenuItem sx={{ fontSize: "13px" }} value={25}>
                        25
                      </MenuItem>
                      <MenuItem sx={{ fontSize: "13px" }} value={50}>
                        50
                      </MenuItem>
                      <MenuItem sx={{ fontSize: "13px" }} value={100}>
                        100
                      </MenuItem>
                    </Select>
                  </FormControl>
                  <Typography sx={{ fontSize: "13px" }}>entries</Typography>
                </Stack>
                <Box>
                  <Stack direction="row" spacing={1} alignItems="center">
                    <Typography sx={{ fontSize: "13px" }}>Search :</Typography>
                    <FormControl size="small">
                      <TextField
                        sx={{ fontSize: "13px" }}
                        size="small"
                        id="outlined-controlled"
                        // label="Controlled"
                        value={search}
                        onChange={(event) => {
                          setSearch(event.target.value);
                        }}
                      />
                    </FormControl>
                  </Stack>
                </Box>
              </Stack>
              <div>
                <Box sx={{ mt: 4, minHeight: "100%" }}>
                  {posts && posts.length !== 0 ? (
                    <Table size="lg" responsive>
                      <thead
                        style={{
                          // backgroundColor: "#F0F1F2",
                          color: "#fff",
                          padding: "10px",
                          backgroundColor: "#FF7534",
                          textAlign: "left",
                          width: "100%",
                        }}
                      >
                        <tr style={{ width: "100%" }}>
                          {tablehead.map((el, id) => {
                            return (
                              <th
                                key={id}
                                style={{
                                  textAlign: "center",
                                  verticalAlign: "middle",
                                  fontSize: "14px",
                                }}
                              >
                                {el}
                              </th>
                            );
                          })}
                        </tr>
                      </thead>
                      <tbody style={{ textAlign: "left", fontSize: "14px" }}>
                        {posts &&
                          posts?.map((el, id) => {
                            return (
                              <tr
                                key={id}
                                style={{
                                  fontSize: "14px",
                                }}
                              >
                                <td
                                  style={{
                                    fontSize: "14px",
                                    textAlign: "center",
                                    verticalAlign: "middle",
                                  }}
                                >
                                  {(page - 1) * pageSize + (id + 1)}
                                </td>
                                <td
                                  style={{
                                    fontSize: "14px",
                                    textAlign: "center",
                                    verticalAlign: "middle",
                                  }}
                                >
                                  {el?.id || "N/A"}
                                </td>
                                <td
                                  style={{
                                    fontSize: "14px",
                                    textAlign: "center",
                                    verticalAlign: "middle",
                                  }}
                                >
                                  {el?.invoices?.[0]?.invoice_number || "Pending"}
                                </td>
                                <td
                                  style={{
                                    fontSize: "14px",
                                    textAlign: "center",
                                    verticalAlign: "middle",
                                  }}
                                >
                                  {el.name || "N/A"}
                                </td>
                                <td
                                  style={{
                                    fontSize: "14px",
                                    textAlign: "center",
                                    verticalAlign: "middle",
                                  }}
                                >
                                  {el.vehicleDisplay || "N/A"}
                                </td>

                                <td
                                  style={{
                                    fontSize: "14px",
                                    textAlign: "center",
                                    verticalAlign: "middle",
                                  }}
                                >
                                  {el.job_requests.length || "0"}
                                </td>

                                <td
                                  style={{
                                    fontSize: "14px",
                                    textAlign: "center",
                                    verticalAlign: "middle",
                                  }}
                                >
                                  <Box sx={{ display: "flex", justifyContent: "center" }}>
                                    <Chip
                                      label={el?.is_paid === 1 ? "Paid" : "Unpaid"}
                                      color={el?.is_paid === 1 ? "success" : "error"}
                                      size="small"
                                    />
                                  </Box>
                                </td>

                                <td
                                  style={{
                                    fontSize: "14px",
                                    textAlign: "center",
                                    verticalAlign: "middle",
                                  }}
                                >
                                  {el?.status === 0
                                    ? "Pending"
                                    : el?.status === 1
                                    ? "Job Confirmed"
                                    : el?.status === 3
                                    ? "Job Started"
                                    : el?.status === 4
                                    ? "Job Completed"
                                    : el?.status === 2 ||
                                      (el?.status === 2 &&
                                        el?.created_by === "customer" &&
                                        el?.is_paid === 1)
                                    ? "Job Ready to Start"
                                    : el?.is_paid === 0 &&
                                      el?.created_by === "customer"
                                    ? "Waiting for Payment"
                                    : "N/A"}
                                </td>

                                <td style={{ textAlign: "center" }}>
                                  <Dropdown>
                                    <OverlayTrigger
                                      rootClose
                                      trigger="click"
                                      placement="bottom"
                                      overlay={
                                        <Popover id="popover-basic">
                                          <Popover.Body>
                                            <Stack gap={2}>
                                              <Dropdown.Item
                                                onClick={(e) => {
                                                  navigate(
                                                    `/master/job/jobs/view/${el.id}`
                                                  );
                                                }}
                                              >
                                                <MdRemoveRedEye size={18} />{" "}
                                                View
                                              </Dropdown.Item>
                                              <Dropdown.Item
                                                onClick={() => {
                                                  setIsInvoiceOpen(true);
                                                }}
                                              >
                                                <MdRemoveRedEye size={18} />{" "}
                                                Invoice
                                              </Dropdown.Item>
                                              <ViewInvoiceModal
                                                isOpen={isInvoiceOpen}
                                                onClose={() =>
                                                  setIsInvoiceOpen(false)
                                                }
                                                id={el?.invoice_id}
                                                driverDetails={
                                                  el?.job_requests?.[0]
                                                }
                                              />
                                              <Dropdown.Item
                                                onClick={() => {
                                                  navigate(
                                                    `/master/job/jobs/${value}/${el?.id}`
                                                  );
                                                }}
                                              >
                                                <MdMode size={18} /> Edit
                                              </Dropdown.Item>
                                              <Dropdown.Item
                                                onClick={() => {
                                                  handleDelete(el.id);
                                                }}
                                              >
                                                <MdDelete size={18} /> Delete
                                              </Dropdown.Item>
                                            </Stack>
                                          </Popover.Body>
                                        </Popover>
                                      }
                                    >
                                      <Dropdown.Toggle
                                        variant="light"
                                        id="dropdown-basic"
                                      >
                                        <BsThreeDotsVertical />
                                      </Dropdown.Toggle>
                                    </OverlayTrigger>
                                  </Dropdown>
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </Table>
                  ) : (
                    <div>
                      <Nodata />
                    </div>
                  )}
                </Box>
                <Box
                  style={{
                    backgroundColor: "#fff",
                    color: "#000",
                    padding: "0px",
                    borderTop: "0px",
                  }}
                >
                  <div className="justify-content-between flex-wrap d-flex align-items-center">
                    <Typography
                      className="footer-text"
                      sx={{ fontSize: "14px" }}
                    >
                      Showing {posts?.from}-{posts?.to} of {posts?.total}{" "}
                      entries
                    </Typography>
                    <Pagination
                      count={pageCount}
                      color="primary"
                      page={page}
                      onChange={handlePageChange}
                      variant="outlined"
                      shape="rounded"
                      renderItem={(item) => (
                        <PaginationItem
                          slots={{
                            previous: () => {
                              return (
                                <Typography sx={{ fontSize: "14px" }}>
                                  Previous
                                </Typography>
                              );
                            },
                            next: () => {
                              return (
                                <Typography sx={{ fontSize: "14px" }}>
                                  Next
                                </Typography>
                              );
                            },
                          }}
                          {...item}
                        />
                      )}
                    />
                  </div>
                </Box>
                {open && (
                  <Popup
                    title="Add New Driver"
                    id={open}
                    handleClose={handleClose}
                    handleDelete={handleClose}
                    fetchdata={fetchdata}
                    setsnackdata={setsnackdata}
                    setOpen={setOpen}
                    actionURL="/api/auth/master/jobs/delete"
                  />
                )}
              </div>{" "}
            </CardContent>
          </Card>
        </>
      )}
    </>
  );
};

class JobList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      windowWidth: window.innerWidth,
    };
  }
  render() {
    return (
      <div>
        {this.state.windowWidth >= 600 ? (
          <Sidebar>
            <Contant />
          </Sidebar>
        ) : (
          <div style={{ width: "95%", margin: "80px auto" }}>
            {" "}
            <Contant />
          </div>
        )}
      </div>
    );
  }
}

export default JobList;
